// src/components/Footer.tsx
import React from 'react';
import { Box, Typography, Container, Button, Link } from '@mui/material';
import LockOutlined from '@mui/icons-material/LockOutlined';

const Footer: React.FC = () => {
  return (
    <Box sx={{ bgcolor: 'background.paper', color: 'text.primary', py: 3 }}>
      <Container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: { xs: 'column', sm: 'row' }, // Stack vertically on small screens
          flexWrap: 'nowrap', // Prevent wrapping
          gap: 1, // Space between elements
        }}
      >
        {/* Login Button */}
        <Button
          href="/admin"
          variant="contained"
          color="secondary"
          startIcon={<LockOutlined sx={{ fontSize: { xs: 14, sm: 18 } }} />}
          aria-label="Login"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '0.70rem', sm: '0.85rem' },
            px: { xs: 1.5, sm: 2.5 },
            py: { xs: 0.5, sm: 0.75 },
            borderRadius: '999px',
            boxShadow: 2,
            whiteSpace: 'nowrap',
            mt: { xs: 1, sm: 0 },
            color: 'common.white',
            '&:hover': { boxShadow: 4 },
          }}
        >
          Login
        </Button>
        {/* Footer Text */}
        <Typography
          variant="body2"
          sx={{
            fontSize: { xs: '0.6rem', sm: '0.75rem' }, // Smaller font size on mobile
            textAlign: { xs: 'center', sm: 'left' }, // Center text on mobile
            whiteSpace: 'nowrap', // Prevent wrapping of the text
          }}
        >
          © 2025{' '}
          <Link
            href="https://scheduify.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: 'inherit' }}
          >
            Powered by Scheduify
          </Link>{' '}
          | All Rights Reserved
        </Typography>

      </Container>
      <Container sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
        <Typography
          variant="caption"
          sx={{
            fontSize: { xs: '0.6rem', sm: '0.7rem' },
            color: 'text.secondary',
            opacity: 0.8,
            textAlign: 'center',
          }}
        >
          reCAPTCHA protected.{' '}
          <Link
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: 'text.secondary' }}
          >
            Privacy
          </Link>{' '}
          •{' '}
          <Link
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: 'text.secondary' }}
          >
            Terms
          </Link>
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
